import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiCallingService } from './api-calling.service';
import { ResponseUtilityService } from './response-utility.service';
import { ApiResponseModel } from '../models/api-response.models';

@Injectable({
  providedIn: 'root'
})
export class PublicLogsService {
  #http = inject(ApiCallingService);
  #responseHandler = inject(ResponseUtilityService);
  postPublicLog(source: string, logData: string): Observable<any> {
    return this.#http
      .postData('GeneralLog', '', { source, logData }, true, undefined, false)
      .pipe(map((res: ApiResponseModel<any>) => this.#responseHandler.handleResponse<any>(res, undefined, false)));
  }
}
